import { lazy, type ReactNode, Suspense } from 'react'
import { ScreenState } from '../app/ScreenState.js'
import './parent.css'

/**
 * WP-F's route elements. `app/src/app/routes.tsx` imports only from here, so the shared route
 * table gains one import line and the lane keeps its own file layout (WORKPLAN §3). Every
 * screen is a lazy chunk, the way `app/src/pet/index.tsx` does it: the parent area is one
 * visit a week and stays out of the app shell (ARCHITECTURE §9, PERF-05). The review mode boot
 * hook lives in `./review.ts` and main.tsx imports it from there, not from this barrel.
 */

const LazyProfilePick = lazy(() =>
  import('./profile/ProfilePick.jsx').then((m) => ({ default: m.ProfilePick })),
)
const LazyParentGate = lazy(() =>
  import('./gate/ParentGate.jsx').then((m) => ({ default: m.ParentGate })),
)
const LazyOnboarding = lazy(() =>
  import('./onboarding/Onboarding.jsx').then((m) => ({ default: m.Onboarding })),
)
const LazyPanel = lazy(() => import('./dashboard/Panel.jsx').then((m) => ({ default: m.Panel })))
const LazyTakvim = lazy(() => import('./dashboard/Takvim.jsx').then((m) => ({ default: m.Takvim })))
const LazyDersler = lazy(() =>
  import('./dashboard/Dersler.jsx').then((m) => ({ default: m.Dersler })),
)
const LazyGozlem = lazy(() => import('./dashboard/Gozlem.jsx').then((m) => ({ default: m.Gozlem })))
const LazyReminders = lazy(() =>
  import('./reminders/Reminders.jsx').then((m) => ({ default: m.Reminders })),
)
const LazyShare = lazy(() => import('./share/Share.jsx').then((m) => ({ default: m.Share })))
const LazySettings = lazy(() =>
  import('./settings/Settings.jsx').then((m) => ({ default: m.Settings })),
)
const LazyPlus = lazy(() => import('./plus/Plus.jsx').then((m) => ({ default: m.Plus })))

function Loading({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <ScreenState status="loading" onRetry={() => window.location.reload()}>
          {null}
        </ScreenState>
      }
    >
      {children}
    </Suspense>
  )
}

export const ProfilePick = () => (
  <Loading>
    <LazyProfilePick />
  </Loading>
)
export const ParentGate = () => (
  <Loading>
    <LazyParentGate />
  </Loading>
)
export const Onboarding = () => (
  <Loading>
    <LazyOnboarding />
  </Loading>
)
export const Panel = () => (
  <Loading>
    <LazyPanel />
  </Loading>
)
export const Takvim = () => (
  <Loading>
    <LazyTakvim />
  </Loading>
)
export const Dersler = () => (
  <Loading>
    <LazyDersler />
  </Loading>
)
export const Gozlem = () => (
  <Loading>
    <LazyGozlem />
  </Loading>
)
export const Reminders = () => (
  <Loading>
    <LazyReminders />
  </Loading>
)
export const Share = () => (
  <Loading>
    <LazyShare />
  </Loading>
)
export const Settings = () => (
  <Loading>
    <LazySettings />
  </Loading>
)
export const Plus = () => (
  <Loading>
    <LazyPlus />
  </Loading>
)
